import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Switch } from 'react-router';
import { BrowserRouter, Link, Route } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';


// Styles
import 'react-toastify/dist/ReactToastify.css';
//import 'react-toastify/scss/main.scss';

// Contexts & error boundaries
import AppContext, { GlobalContextProvider } from '../contexts/AppContext';
import AppErrorBoundary from "../boundaries/AppErrorBoundary";

// Higher order components
import { withTranslation } from 'react-i18next';
import ErrorHandler from "./hoc/ErrorHandler";

// Translations
import './i18n';

// Landing page
import Landing from '../containers/Landing';

// Main routes (authorisation & etc)
import Login from '../containers/Auth/Login/Login';
import Register from '../containers/Auth/Register/Register';
import EmailConfirmation from '../containers/Auth/EmailConfirmation/EmailConfirmation';
import Logout from '../containers/Auth/Logout/Logout';
import ForgotPassword from '../containers/Auth/ForgotPassword/ForgotPassword';
import ResetPassword from '../containers/Auth/ResetPassword/ResetPassword';
import Process from '../containers/Process';
import PageNotFound from "../containers/ErrorPages/PageNotFound";

// Dashboard
import Dashboard from '../containers/Dashboard';
import CreateApplication from "../containers/ProcessSteps/CreateApplication";

// Remote sign document
import DocumentPreview from '../containers/ProcessSteps/RemoteSignDoc/DocumentPreview';
import WaitingDocument from '../containers/ProcessSteps/RemoteSignDoc/WaitingDocument';

// Eshop
import InitEshopProcess from '../containers/ProcessSteps/Eshop/InitEshopProcess';

// Indivy Plan
import InitIndivyPlanProcess from '../containers/ProcessSteps/InitIndivyPlanProcess';


let Header = (props) => {
    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-primary">
            <div className="container">

                <ToastContainer/>
                <Link className="navbar-brand" to="/">Logo</Link>

                <button className="navbar-toggler" type="button" data-toggle="collapse"
                        data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    {props.is_logged_in ? <LoggedInMenu/> : <GuestMenuMenu/>}
                </div>
            </div>
        </nav>
    );
};

let LoggedInMenu = (props) => {
    return (
        <ul className="navbar-nav ml-auto">
            <li className="nav-item">
                <Link
                    className="btn btn-primary"
                    to="/dashboard">Dashboard</Link>
            </li>
            <li className="nav-item">
                <Link className="btn btn-primary" to="/logout">Logout</Link>
            </li>
            <li className="nav-item">
                <Link className="nav-link" to="/create_application">Create Application</Link>
            </li>
        </ul>
    )
};

let GuestMenuMenu = (props) => {
    return (
        <ul className="navbar-nav ml-auto">
            <li className="nav-item">
                <Link className="nav-link" to="/auth/login">Log In</Link>
            </li>
            <li className="nav-item">
                <Link className="nav-link" to="/auth/register">Register</Link>
            </li>
            <li className="nav-item">
                <Link className="nav-link" to="/create_application">Create Application</Link>
            </li>
        </ul>
    )
};


class App extends Component {

    static contextType = AppContext;

    constructor(props) {
        super(props);

        this.state = {
            is_logged_in: props.is_logged_in,
            user: {},
        };

        if (props.is_logged_in) {
            this.getUserInfo();
        }

        this.mark_as_logged_in = this.mark_as_logged_in.bind(this);
        this.mark_as_logged_out = this.mark_as_logged_out.bind(this);
        this.getUserInfo = this.getUserInfo.bind(this);
    }

    getUserInfo() {
        axios.get('/api/profile').then(
            data => {
                this.setState({user: data.data})
            },
            error => {
                toast.error(error.response.data.message)
            }
        )
            .catch((a, b, c) => {
                console.log(a, b, c);
            });
    }

    mark_as_logged_in() {
        this.setState({ is_logged_in: true });
        this.getUserInfo();
    }

    mark_as_logged_out() {
        this.setState({
            is_logged_in: false,
            user: {},
        });
    }

    render() {
        return (
            <GlobalContextProvider>
                <BrowserRouter>
                    {/*<main role="main">  tag seems to be unnecessary yet throws an error in IE */}
                        <ToastContainer/>
                        <ErrorHandler>
                            <AppErrorBoundary>
                                <Switch>
                                    <Route exact path="/" component={Landing}/>
                                    <Route path="/auth/login"
                                           render={
                                               (props) => {
                                                   return (<Login {...props} mark_as_logged_in={this.mark_as_logged_in}
                                                                  is_logged_in={this.state.is_logged_in}/>)
                                               }
                                           }/>
                                    <Route path="/auth/register" render={
                                        (props) => (<Register {...props} is_logged_in={this.state.is_logged_in}/>)
                                    }/>
                                    <Route path="/auth/forgot_password" render={
                                        (props) => (<ForgotPassword {...props} is_logged_in={this.state.is_logged_in}/>)
                                    }/>
                                    <Route path="/auth/reset_password/:email/:token" render={
                                        (props) => (<ResetPassword {...props} is_logged_in={this.state.is_logged_in}
                                                                   mark_as_logged_in={this.mark_as_logged_in}/>)
                                    }/>
                                    <Route path="/auth/confirm_email/:token" render={
                                        (props) => (<EmailConfirmation {...props} is_logged_in={this.state.is_logged_in}
                                                                       mark_as_logged_in={this.mark_as_logged_in}/>)
                                    }/>
                                    <Route path="/dashboard" render={
                                        (props) => (
                                            <Dashboard {...props} is_logged_in={this.state.is_logged_in}
                                                       user={this.state.user}
                                                       mark_as_logged_in={this.mark_as_logged_in}/>)
                                    }/>
                                    <Route path="/logout" render={
                                        (props) => (<Logout {...props} is_logged_in={this.state.is_logged_in}
                                                            mark_as_logged_out={this.mark_as_logged_out}/>)
                                    }/>
                                    <Route path="/sign_document/:token/:substep?" render={
                                        (props) => (<DocumentPreview {...props}/>)
                                    }/>
                                    <Route path="/waiting_document/:token/:done?" render={
                                        (props) => (<WaitingDocument {...props}/>)
                                    }/>
                                    <Route path={["/create_application"]} render={
                                        (props) => (<CreateApplication {...props} />)
                                    }/>
                                    <Route path={["/eshop/:token([A-Z|0-9]{40})"]} render={
                                        (props) => (<InitEshopProcess {...props} />)
                                    }/>
                                    <Route
                                        path={["/:application_token([A-Z|0-9]{40})/process/:step/:error_code", "/:application_token([A-Z|0-9]{40})/process/:step"]}
                                        render={
                                            (props) => (<Process {...props} />)
                                    }/>

                                    {/* Indivy Plan (init) */}
                                    <Route path={["/ip/:token([A-Z|0-9]{40})/init"]} render={
                                        (props) => (<InitIndivyPlanProcess {...props} />)
                                    }/>

                                    {/* 404 page*/}
                                    <Route component={PageNotFound}/>
                                </Switch>
                            </AppErrorBoundary>

                            {/*<Header is_logged_in={this.state.is_logged_in}/>*/}
                        </ErrorHandler>
                    {/*</main>*/}
                </BrowserRouter>
            </GlobalContextProvider>
        );
    }
}

const TranslatedApp = withTranslation()(App);

const appDomElement = document.getElementById('app');

if (appDomElement) {
    const props = JSON.parse(appDomElement.dataset.props);
    delete appDomElement.dataset.props;
    ReactDOM.render(<TranslatedApp {...props} />, appDomElement);
}
